import React from "react";

const DynamicField = ({ field, value, onChange, error }) => {
    const { name, type, properties = {} } = field;
    const {
        label,
        hidden,
        disabled,
        required,
        placeholder,
        options = [],
    } = properties;

    if (hidden) return null;

    const renderControl = () => {

        if (type === "Heading") {

            return (<div className="formHeading">
                <div>
                    <h2 className="formHeading" style={{ lineHeight: 0, marginBottom: 0 }}>{properties.heading}</h2>
                </div>
                <div>
                    <h5>{properties.subheading}</h5>
                </div>
            </div>)
        }






        if (type === "dropdown") {
            return (
                <select
                    name={name}
                    value={value || ""}
                    disabled={disabled}
                    onChange={(e) => onChange(name, e.target.value, field)}
                >
                    <option value="" disabled>
                        {placeholder || "Select"}
                    </option>
                    {options.map((opt, i) => (
                        <option key={i} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            );
        }

        if (type === "textarea") {
            return (
                <textarea
                    name={name}
                    value={value || ""}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={(e) => onChange(name, e.target.value, field)}
                />
            );
        }

        if (type === "checkbox") {
            return (
                <input
                    type="checkbox"
                    name={name}
                    checked={!!value}
                    disabled={disabled}
                    onChange={(e) => onChange(name, e.target.checked, field)}
                />
            );
        }

        const inputType =
            type === "number" ? "tel" : type === "email" ? "email" : type || "text";

        return (
            <input
                type={inputType}
                name={name}
                value={value || ""}
                disabled={disabled}
                placeholder={placeholder}
                onChange={(e) => onChange(name, e.target.value, field)}
            />
        );
    };

    return (
        <>
            <div className="form-group">
                {
                    type !== "Heading" && (
                        <label>
                            {label}
                            {required && <span className="mandatory-field"> * </span>} :
                        </label>
                    )
                }

                {renderControl()}
            </div>
            {error && <p className="textDanger">{error}</p>}
        </>
    );
};

export default DynamicField;
